import { theme as defaultTheme } from "@mindlercare/ui-web";
import { styled } from "styled-components";

export const EmptyContainer = styled.div`
  height: fit-content;
  padding: 16px 0;
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${(p) => defaultTheme.COLORS.GRAY_MEDIUM};
`;
